import styled from 'styled-components';

import { MenuItem } from '@mui/material';

export const CardHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  min-height: 68px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
`;

export const StyledMenuItem = styled(MenuItem)`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.15px;
`;
